import SchoolsSerializer from './base';

export default class Location extends SchoolsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      canBeTimetabled: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
